<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faExclamationTriangle,
);

export default {
  props: {
    stateId: {
      type: String,
      // required: true,
    },
  },
};
</script>

<template>
  <div class="document-container">
    <div class="document">
      <div class="near-match-box">
        <div class="header-row is-flex">
          <div class="warning is-flex flex-align--center flex-justify--center">
            <font-awesome-icon
              class="has-text-white fa-2x"
              :icon="['fas', 'exclamation-triangle']"
            />
          </div>
          <div class="header-row--heading is-flex">
            <div class="is-flex header-row--description grow">
              <div
                class="is-flex header-row--cell has-text-weight-bold
                  is-size-4 flex-align--center nowrap"
              >
                MATCH FOUND:
              </div>
              <div class="header-row--cell grow has-text-weight-bold has-text-left border--left">
                <div class="has-text-grey-light">
                  The new location you submitted already exists in the system
                  and was linked to State Location ID: {{ stateId }}.
                </div>
                <div class="">
                  Next Steps: Edit Contact information, Edit Grades,
                  Edit Facility Types, Edit Attributes, View Location Group
                </div>
              </div>
            </div>
            <div
              class="is-flex header-row--cell flex-justify--center
                flex-direction--column border--left"
            >
              <div class="has-text-weight-bold is-size-5">
                {{ stateId }}
              </div>
              <div class="nowrap is-size-7 has-text-grey">
                State ID Assigned
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  @import "~bulma/sass/utilities/mixins"
  +touch
    .header-row--description
      flex-direction: column
      border-left: none

  .document-container
    padding-bottom: 0
  .header-row
    min-height: 60px
    .warning
      background-color: blue
      min-height: 60px
      min-width: 60px
  .header-row--heading
    width: 100%
    padding: 0.5rem 0
    border-bottom: 1px solid #eee
  .header-row--cell
    padding: 0 1rem
  .header-row--button
    padding: 1rem

  .border--left
    border-left: 1px solid #ccc
</style>
